import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import logger from '../../../../shared/functions/Logger/logger.functions'
import { LogSystem } from '../../../../shared/functions/Logger/logger.types'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { createFlightBookingApi } from './createFlightBooking.api'
import createFlightBookingInitialState from './createFlightBooking.initialState'
import { CreateFlightBookingErrorResponse, CreateFlightBookingRequestPayload } from './createFlightBooking.types'

export const createFlightBooking = createAsyncThunk(
  urls.flights.createFlightBooking,
  async (payload: CreateFlightBookingRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess, onError } = payload

    try {
      const response = await createFlightBookingApi(request)

      logger.logEvent(
        'flight_booked_success',
        {
          email: request.passengers[0].email || ''
        },
        [LogSystem.metaPixel]
      )

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse, onError, true)

      return rejectWithValue(error)
    }
  }
)

const createFlightBookingSlice = createSlice({
  name: urls.flights.createFlightBooking,
  initialState: createFlightBookingInitialState,
  reducers: {
    resetCreateFlightBooking: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFlightBooking.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(createFlightBooking.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(createFlightBooking.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as CreateFlightBookingErrorResponse
        state.success = null
      })
  }
})

export const { actions: createFlightBookingActions, reducer: createFlightBookingReducer } = createFlightBookingSlice
export const { resetCreateFlightBooking } = createFlightBookingActions
export default createFlightBookingSlice.reducer
